import React from "react";
import { Router } from "@src/routes/Router";
import "./i18n";

const App: React.FC = () => {
  return <Router />;
};

export default App;
